import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';

const SrInfoSimpleChecklist = ({ title, listItems }) => (
  <SrBox borderRadius="7px" backgroundColor="rgba(246, 247, 247, 0.8)" padding="16px 18px">
    <SrText
      font="greycliff"
      size="16"
      weight="800"
      lineHeight="19px"
      color="blueGreycliff"
      display="block"
    >
      {title}
    </SrText>
    {listItems.map((listItem) => (
      <SrBox marginTop="8px">
        <SrBox marginRight="12px" display="inlineBlock">
          <SrIcon className="checkmark-rounded-blue" />
        </SrBox>
        <SrText font="greycliff" size="16" weight="600" lineHeight="24px" color="blueGreycliff">
          {listItem}
        </SrText>
      </SrBox>
    ))}
  </SrBox>
);

SrInfoSimpleChecklist.propTypes = {
  title: PropTypes.string.isRequired,
  listItems: PropTypes.array.isRequired,
};

SrInfoSimpleChecklist.displayName = 'SrInfoSimpleChecklist';

export default SrInfoSimpleChecklist;
